export default function formatStake(stake) {
  return parseInt(stake.toFixed(2) * 100, 10);
}
